import { useEffect } from "react";

import { AppPricingData } from "src/contentful";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";
import { UserLocale } from "@/utils/useGeoCurrency";

import { SoftwareCompassPricingPageTemplate } from "../../../../templates/software/compass/pricing/src/software-compass-pricing-page.template";

export type SoftwareCompassPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
};
export const SoftwareCompassPricingPage = ({
    pricing,
    countryCode,
    pricingContent
}: SoftwareCompassPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="compass"
            pricingContent={pricingContent}
        >
            <div data-testid="compass-pricing-page">
                <SoftwareCompassPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProvider>
    );
};
